import * as _ from "lodash";
import moment from 'moment';

/**
 * @summary Empty Checker
 * @description Checks whether an array or object is empty.
 * @param {object} data
 * @author Papu Kumar <papu.kumar@kelltontech.com>
 * @return {boolean}
 */
export const checkEmpty = (data) => _.isEmpty(data);

export const dateParser = (date = "", format = "") => {
    return moment(date).utcOffset("+05:30").format(format);
};

export const dateFormateWithoutUTC = (date = "", format = "") => {
  return moment(date).format(format).toLocaleString('en-US', 
  { 
    timeZone: 'Asia/Kolkata',  
    hour12: false,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

export const statusToText = (data) => {
  let statusName;
  if (data == 0) {
    statusName = 'In Progress';
  } else if (data == 1) {
    statusName = 'Accepted';
  } else if (data == 0) {
    statusName = 'Failed';
  }
  return statusName;
} 

export  const statusToTextActiveInactive = (data) => {
  let statusName;
  if (data == 0) {
    statusName = 'Inactive';
  } else if (data == 1) {
    statusName = 'Active';
  }
  return statusName;
}